import { cn } from "@/lib/utils";

export function LocationIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-4 text-dark-raspberry", className)}
      fill="none"
      viewBox="0 0 16 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.857 8.357C14.857 13.344 8 19.5 8 19.5S1.143 13.344 1.143 8.357a6.857 6.857 0 0113.714 0z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="8"
        cy="8.269"
        r="2.5"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function SearchIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[15px] w-[14px] text-white", className)}
      fill="none"
      viewBox="0 0 14 15"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.005 13.402l-2.703-2.659"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.364"
      />
      <ellipse
        cx="6.458"
        cy="6.965"
        rx="5.457"
        ry="5.368"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.364"
      />
    </svg>
  );
}

export function QueryIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-5 text-dark-raspberry", className)}
      fill="none"
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 19.5l-4.055-4.055"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="9.185"
        cy="9.685"
        r="8.185"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
